import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../shared';

export default function AnnouncementBanner() {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(sessionStorage.getItem('annDismissed') === '1');

  useEffect(() => {
    axios.get(`${API_URL}/api/announcement`)
      .then(r => { if (r.data && r.data.enabled) setBanner(r.data); })
      .catch(() => {});
  }, []);

  if (!banner || dismissed) return null;

  return (
    <div data-testid="announcement-banner" style={{ background: banner.color || '#ff6b35', color: 'white', padding: '10px 16px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '14px', fontSize: '14px', fontWeight: 500, flexWrap: 'wrap', position: 'relative' }}>
      <span>{banner.text}</span>
      {banner.link && (
        <a href={banner.link} style={{ color: 'white', textDecoration: 'underline', fontWeight: 700 }}>
          {banner.link_text || 'Mehr erfahren'}
        </a>
      )}
      <button
        onClick={() => { sessionStorage.setItem('annDismissed', '1'); setDismissed(true); }}
        data-testid="announcement-dismiss"
        style={{ position: 'absolute', right: '12px', background: 'rgba(255,255,255,0.25)', border: 'none', color: 'white', borderRadius: '50%', width: '24px', height: '24px', cursor: 'pointer', lineHeight: 1 }}
        aria-label="Banner schließen"
      >×</button>
    </div>
  );
}
